import mshubPayload from '@/utils/mshubPayload'

const CartaoVirtualApi = (API) => {
  return {
    async carregar (modelo) {
      let url = process.env.VUE_APP_SETUP_CARTAO_VIRTUAL

      const payload = mshubPayload({
        modelos: [].concat(modelo)
      })
      return API.post(url, payload, {
        headers: {
          bundle: payload.sistema.app.bundle
        }
      })
    }
  }
}

export default CartaoVirtualApi
